import styled from 'styled-components';

import { Text } from '@gympass/yoga';
import { wellzTheme } from '@wellz-theme/mui';

export const ImgContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const DivImg = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.yoga.spacing.medium}px;

  svg {
    width: ${wellzTheme.spacing(16)};
    height: ${wellzTheme.spacing(5)};
  }

  @media screen and (max-width: 1440px) {
    display: flex;

    svg {
      height: ${wellzTheme.spacing(3.5)};
      width: ${wellzTheme.spacing(11.5)};
      margin-bottom: ${wellzTheme.spacing(1)};
    }
  }
`;

export const Title = styled(Text.Tiny)`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const BackgroundImg = styled.div`
  width: 202px;
  height: 97px;
  border-radius: ${({ theme }) => theme.yoga.radii.regular}px;
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};

  @media (max-width: 1024px) {
    height: fit-content;
    width: fit-content;
    display: block;
    background: transparent;

    ${Title} {
      display: none;
    }

    ${DivImg} {
      padding: 0;
    }
  }

  @media screen and (max-width: 1440px) and (min-width: 1024px) {
    display: none;
  }
`;

export const SmallLogoWrapper = styled.div`
  display: none;

  @media screen and (max-width: 1440px) and (min-width: 1024px) {
    display: flex;

    svg {
      height: ${wellzTheme.spacing(6)};
      width: ${wellzTheme.spacing(6)};
    }
  }
`;
